export const validation = {
  receipt: {
    max_chars_8: 'Debe contener como máximo 8 caracteres',
    max_chars_50: 'Debe contener como máximo 50 caracteres',
    max_number_1000: 'El valor máximo debe ser 1000',
    min_number_0: 'El valor mínimo debe ser 0',
    maxTwoDecimals: 'Debe contener como máximo 2 decimales',
  },
};
